import React from "react";

export default function TermsOfService() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto px-6 py-16">

        <h1 className="text-4xl font-bold text-gray-900 mb-3">
          Terms of Service
        </h1>

        <p className="text-gray-500 mb-10">
          Last Updated: August 2026
        </p>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12 space-y-10">

          <section>
            <p className="text-gray-700 leading-8">
              Welcome to <strong>SQIT.ai</strong>, a product of
              <strong> Bionivid Technology Pvt. Ltd.</strong> By accessing or
              using our platform, website, software, and services, you agree to
              comply with these Terms of Service. If you do not agree with these
              terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              1. Eligibility
            </h2>

            <p className="text-gray-700 leading-8">
              You must be legally capable of entering into a binding agreement
              to use SQIT.ai. By using our services, you represent that you have
              the authority to accept these Terms on behalf of yourself or your
              organization.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              2. User Accounts
            </h2>

            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>You are responsible for maintaining your account credentials.</li>
              <li>Provide accurate and up-to-date information.</li>
              <li>Notify us immediately of any unauthorized account access.</li>
              <li>You are responsible for all activities performed under your account.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              3. Acceptable Use
            </h2>

            <p className="text-gray-700 mb-4">
              You agree not to:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Use the platform for unlawful purposes.</li>
              <li>Attempt to gain unauthorized access to our systems.</li>
              <li>Disrupt or interfere with platform operations.</li>
              <li>Upload malicious software or harmful content.</li>
              <li>Misuse computational resources.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              4. Scientific Data
            </h2>

            <p className="text-gray-700 leading-8">
              Users retain ownership of all uploaded datasets and research
              materials. SQIT.ai processes uploaded data solely for providing
              requested bioinformatics analyses and does not claim ownership of
              customer data.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              5. Payments and Credits
            </h2>

            <p className="text-gray-700 leading-8">
              Certain services may require payment or platform credits.
              Applicable pricing, billing terms, and payment policies will be
              displayed before purchase. Unless otherwise stated, completed
              purchases are non-refundable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              6. Intellectual Property
            </h2>

            <p className="text-gray-700 leading-8">
              All platform software, designs, documentation, branding, logos,
              graphics, and related intellectual property remain the exclusive
              property of Bionivid Technology Pvt. Ltd. Users may not reproduce,
              distribute, modify, or reverse engineer any part of the platform
              without prior written permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              7. Service Availability
            </h2>

            <p className="text-gray-700 leading-8">
              We strive to maintain uninterrupted availability but do not
              guarantee continuous operation. Scheduled maintenance, upgrades,
              or unforeseen technical issues may temporarily affect service
              availability.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              8. Disclaimer
            </h2>

            <p className="text-gray-700 leading-8">
              SQIT.ai provides computational bioinformatics analysis tools.
              Results generated by the platform are intended for research and
              scientific purposes and should not be interpreted as medical,
              clinical, or diagnostic advice unless explicitly stated.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              9. Limitation of Liability
            </h2>

            <p className="text-gray-700 leading-8">
              To the fullest extent permitted by law, Bionivid Technology Pvt.
              Ltd. shall not be liable for indirect, incidental, special,
              consequential, or punitive damages arising from the use or
              inability to use the platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              10. Termination
            </h2>

            <p className="text-gray-700 leading-8">
              We reserve the right to suspend or terminate accounts that violate
              these Terms, engage in fraudulent activity, or misuse the
              platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              11. Changes to These Terms
            </h2>

            <p className="text-gray-700 leading-8">
              We may revise these Terms of Service from time to time. Updated
              versions will be published on this page with the revised "Last
              Updated" date. Continued use of the platform constitutes
              acceptance of the revised Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              12. Governing Law
            </h2>

            <p className="text-gray-700 leading-8">
              These Terms shall be governed by and interpreted in accordance
              with the laws of India. Any disputes arising from these Terms
              shall be subject to the jurisdiction of the courts in Bengaluru,
              Karnataka.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              13. Contact Us
            </h2>

            <div className="rounded-xl bg-green-50 border border-green-200 p-6">
              <p className="font-semibold text-lg">
                Bionivid Technology Pvt. Ltd.
              </p>

              <p className="mt-3">
                <strong>Platform:</strong> SQIT.ai™ Bioinformatics Platform
              </p>

              <p>
                <strong>Email:</strong> info@bionivid.com
              </p>

            </div>
          </section>

        </div>
      </div>
    </div>
  );
}